<mat-card-content>
    <ng-content></ng-content>
</mat-card-content>
